import React, { useState } from 'react';
import '../styles/AchievementsSection.css';

const AchievementsSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedAchievement, setSelectedAchievement] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const achievements = [
    {
      id: 1,
      image: '/images/DOI-TAC.png',
      title: 'STRIDE',
      subtitle: 'ĐỐI TÁC XUẤT SẮC NĂM 2024',
      description: 'Được công nhận bởi Stride là đối tác xuất sắc trong việc cung cấp giải pháp công nghệ.',
      details: {
        date: 'Tháng 12/2024',
        organization: 'Stride Corporation',
        criteria: [
          'Chất lượng dịch vụ xuất sắc',
          'Thời gian triển khai nhanh chóng',
          'Hỗ trợ khách hàng 24/7',
          'Đổi mới sáng tạo trong giải pháp'
        ],
        benefits: [
          'Được ưu tiên trong các dự án lớn',
          'Hỗ trợ kỹ thuật trực tiếp từ Stride',
          'Chiết khấu đặc biệt cho sản phẩm',
          'Đào tạo miễn phí cho nhân viên'
        ],
        impact: 'Giúp PhucAn Solutions mở rộng thị trường và nâng cao năng lực cạnh tranh trong lĩnh vực IoT và Smart Home.'
      }
    },
    {
      id: 2,
      image: '/images/TOP10.png',
      title: 'TOP 10 THƯƠNG HIỆU MẠNH',
      subtitle: 'QUỐC GIA NĂM 2025',
      description: 'Vinh dự được xếp hạng trong Top 10 Thương hiệu mạnh quốc gia, khẳng định vị thế của Phúc An Solutions trên thị trường.',
      details: {
        date: 'Tháng 1/2025',
        organization: 'Hiệp hội Thương hiệu Việt Nam',
        criteria: [
          'Doanh thu tăng trưởng bền vững',
          'Độ nhận diện thương hiệu cao',
          'Chất lượng sản phẩm/dịch vụ',
          'Uy tín và niềm tin khách hàng'
        ],
        benefits: [
          'Tăng cường độ tin cậy từ khách hàng',
          'Mở rộng cơ hội hợp tác quốc tế',
          'Ưu tiên trong các dự án chính phủ',
          'Tiếp cận nguồn vốn đầu tư dễ dàng hơn'
        ],
        impact: 'Khẳng định vị thế dẫn đầu của PhucAn Solutions trong ngành công nghệ và năng lượng tái tạo tại Việt Nam.'
      }
    },
    {
      id: 3,
      image: '/images/TOP-20.png',
      title: 'TOP 20 THƯƠNG HIỆU XANH',
      subtitle: 'VIỆT NAM NĂM 2025',
      description: 'Phúc An Solutions tự hào được công nhận là một trong 20 Thương hiệu xanh Việt Nam, cam kết vì một tương lai bền vững.',
      details: {
        date: 'Tháng 2/2025',
        organization: 'Bộ Tài nguyên và Môi trường',
        criteria: [
          'Cam kết phát triển bền vững',
          'Sử dụng năng lượng tái tạo',
          'Giảm thiểu tác động môi trường',
          'Đóng góp vào mục tiêu carbon trung hòa'
        ],
        benefits: [
          'Ưu đãi thuế cho doanh nghiệp xanh',
          'Hỗ trợ vay vốn ưu đãi',
          'Ưu tiên trong đấu thầu dự án môi trường',
          'Quảng bá thương hiệu trên các phương tiện truyền thông'
        ],
        impact: 'Góp phần thúc đẩy phong trào phát triển bền vững và bảo vệ môi trường tại Việt Nam, đồng thời nâng cao uy tín của công ty.'
      }
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === achievements.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? achievements.length - 1 : prev - 1));
  };

  const openModal = (achievement) => {
    setSelectedAchievement(achievement);
    setIsModalOpen(true);
    // Lưu vị trí scroll hiện tại
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.dataset.scrollTop = scrollTop;
    document.body.style.top = `-${scrollTop}px`;
    document.body.classList.add('modal-open');
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedAchievement(null);
    // Khôi phục vị trí scroll
    const scrollTop = parseInt(document.body.dataset.scrollTop || '0');
    document.body.classList.remove('modal-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollTop);
  };

  // Close modal when clicking outside
  const handleModalClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // Close modal with Escape key
  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isModalOpen) {
        closeModal();
      }
    };
    
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isModalOpen]);

  return (
    <section className="achievements-section" id="achievements">
      <div className="container">
        <h2 className="section-title">THÀNH TỰU ĐẠT ĐƯỢC</h2>
        
        <div className="achievements-container">
          <button className="nav-btn prev-btn" onClick={prevSlide}>
            <span>«</span>
          </button>
          
          <div className="achievements-grid">
            {achievements.map((achievement, index) => (
              <div key={achievement.id} className="achievement-card">
                <div className="achievement-image">
                  <img src={achievement.image} alt={achievement.title} />
                </div>
                <div className="achievement-info">
                  <h3 className="achievement-title">{achievement.title}</h3>
                  <h4 className="achievement-subtitle">{achievement.subtitle}</h4>
                  <p className="achievement-description">{achievement.description}</p>
                  <button 
                    className="detail-btn"
                    onClick={() => openModal(achievement)}
                  >
                    Xem chi tiết
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          <button className="nav-btn next-btn" onClick={nextSlide}>
            <span>»</span>
          </button>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && selectedAchievement && (
        <div className="modal-overlay" onClick={handleModalClick}>
          <div className="modal-content">
            <button className="modal-close" onClick={closeModal}>
              <span>&times;</span>
            </button>
            
            <div className="modal-header">
              <div className="modal-image">
                <img src={selectedAchievement.image} alt={selectedAchievement.title} />
              </div>
              <div className="modal-title-section">
                <h3>{selectedAchievement.title}</h3>
                <h4>{selectedAchievement.subtitle}</h4>
                <p className="modal-date">{selectedAchievement.details.date}</p>
                <p className="modal-organization">
                  <strong>Tổ chức trao giải:</strong> {selectedAchievement.details.organization}
                </p>
              </div>
            </div>

            <div className="modal-body">
              <div className="modal-section">
                <h5>🎯 Tiêu chí đánh giá</h5>
                <ul>
                  {selectedAchievement.details.criteria.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

              <div className="modal-section">
                <h5>🏆 Quyền lợi và ưu đãi</h5>
                <ul>
                  {selectedAchievement.details.benefits.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

              <div className="modal-section">
                <h5>🚀 Tác động và ý nghĩa</h5>
                <p>{selectedAchievement.details.impact}</p>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn-primary" onClick={closeModal}>
                ✨ Đóng
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default AchievementsSection; 